import { Switch, SwitchProps, useTheme } from "@mui/material"
import React from "react"

const AppSwitch: React.FC<SwitchProps> = (props: SwitchProps) => {
    const theme = useTheme()
    return (
        <Switch
            focusVisibleClassName=".Mui-focusVisible"
            disableRipple
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            sx={{
                width: 46,
                height: 30,
                padding: "2px",
                margin: 0,
                "& .MuiSwitch-switchBase": {
                    padding: 0,
                    "&.Mui-checked": {
                        transform: "translateX(16px)",
                        color: "common.white",
                        "& + .MuiSwitch-track": {
                            backgroundColor: "control.main",
                            opacity: 1,
                            border: "1px",
                            borderColor: "transparent",
                        },
                        "&.Mui-disabled + .MuiSwitch-track": {
                            opacity: 0.7,
                        },
                    },
                    "&.PrivateSwitchBase-input": {
                        width: "200%",
                        left: 0,
                    },
                    "&.Mui-focusVisible .MuiSwitch-thumb": {
                        color: "control.main",
                        borderWidth: "6px",
                        borderStyle: "solid",
                        borderColor: "common.white",
                    },
                    "&.Mui-disabled .MuiSwitch-thumb": {
                        color: "common.white",
                    },
                    "&.Mui-disabled + .MuiSwitch-track": {
                        opacity: 0.7,
                    },
                },
                "& .MuiSwitch-thumb": {
                    margin: "5px",
                    boxSizing: "border-box",
                    width: 20,
                    height: 20,
                },
                "& .MuiSwitch-track": {
                    border: "1px",
                    borderColor: "transparent",
                    borderRadius: 15,
                    backgroundColor: theme.palette.grey[500],
                    opacity: 1,
                    transition: theme.transitions.create(["background-color"], {
                        duration: 500,
                    }),
                },
            }}
        />
    )
}

export default AppSwitch
